import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { DEFAULT_ZIPCODE } from '../../../constants/defaults';
import CustomQuantity from './CustomQuantity';
import { useTranslation } from 'react-i18next';
import SelectDiv from '../../common/Tag/SelectDiv';
import SelectList from '../../common/Tag/SelectList';
import loadable from '@loadable/component';
import Zipcode from '../../common/zipcode';
// import Advertisting from "../Advertisting";
// import { ADS_PLACEMENT } from "../Advertisting/Constant";
import PatientCompassAd from '../../common/PatientCompassAd';
import { ADS_PLACEMENT } from '../Advertisting/Constant';
import SaveDrug from './SaveDrug';
const { API } = require('../../../config/' + process.env.REACT_APP_ENV);
const PriceAlerts = loadable(() => import('./PriceAlerts/index.js'));

const DosageSelection = props => {
  const {
    brandTypes = [],
    drugNdc,
    zipCode,
    patientCompassData,
    showTieredPricingLoader,
    customQuantity = '',
    updateDosage,
    defaultKeys
  } = props;
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDosageOpen, setIsDosageOpen] = useState(false);
  const [isQuantityOpen, setIsQuantityOpen] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [selectedBrand, setSelectedBrand] = useState({
    isGeneric: props.brandTypes[0].isGeneric,
    brand: defaultKeys.name
  });
  const [selectedForm, setSelectedForm] = useState(defaultKeys.form);
  const [selectedDosage, setSelectedDosage] = useState(defaultKeys.dosage);
  const [selectedQuantity, setSelectedQuantity] = useState(
    defaultKeys.displayQuantity
  );
  const [customQty, setCustomQty] = useState('');
  const [showPriceModal, setShowPriceModal] = useState(false);
  const wrapperRef = useRef(null);
  const { t, i18n } = useTranslation();
  const { brandId, dosageId, formId, quantityId } = props.drugIds;
  const formTypes = !_.isEmpty(brandTypes) && brandTypes[brandId].formTypes;
  const { dosage } = !_.isEmpty(formTypes) && formTypes[formId];
  const { quantities } = !_.isEmpty(dosage) && dosage[dosageId];
  const zipcodeValue =
    typeof localStorage !== 'undefined' &&
    localStorage.getItem('zipCodeData') &&
    JSON.parse(localStorage.getItem('zipCodeData')).zipCode;
  let finalDisplayQty =
    customQty && !_.isEmpty(customQty) ? customQty : selectedQuantity;

  useEffect(() => {
    if (window.location.hash && API.ALLOW_PRICE_ALERT) {
      const sectionId = window.location.hash.substr(1);
      if (sectionId.match('price-alert')) setShowPriceModal(true);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showPriceModal ? 'hidden' : '';
  }, [showPriceModal]);

  useEffect(() => {
    const { brandId, dosageId, formId, quantityId } = props.drugIds;
    const formTypes = props.brandTypes[brandId]?.formTypes || {};
    const dosage = formTypes[formId]?.dosage || {};
    const quantities = dosage[dosageId]?.quantities || {};
    if (!isFirstLoad) {
      setSelectedBrand(props.brandTypes[brandId]);
      setSelectedForm(formTypes[formId]?.name);
      setSelectedDosage(dosage[dosageId]?.dosage);
      setSelectedQuantity(quantities[quantityId]?.displayQuantity);
    } else {
      setIsFirstLoad(false);
    }
    setCustomQty(customQuantity);
    if (customQuantity !== customQty) {
      setCustomQty(customQuantity);
    }
  }, [props.drugIds, customQuantity]);

  const toggleDropDown = type => {
    let evtObj = {
      ...props.dataLayerEventObj,
      event: 'drugFilterDropdownSelect',
      formId: 'dosage'
    };
    switch (type) {
      case 'brand': {
        setIsBrandOpen(!isBrandOpen);
        setIsFormOpen(false);
        setIsDosageOpen(false);
        setIsQuantityOpen(false);
        evtObj.clickText = 'SELECT BRAND';
        evtObj.drugFilterName = type;
        if (!isBrandOpen) _.triggerGTMVirtualPageViewEvent(evtObj);
        break;
      }
      case 'form': {
        setIsBrandOpen(false);
        setIsFormOpen(!isFormOpen);
        setIsDosageOpen(false);
        setIsQuantityOpen(false);
        evtObj.clickText = 'SELECT FORM';
        evtObj.drugFilterName = type;
        if (!isFormOpen) _.triggerGTMVirtualPageViewEvent(evtObj);
        break;
      }
      case 'dosage': {
        setIsBrandOpen(false);
        setIsFormOpen(false);
        setIsDosageOpen(!isDosageOpen);
        setIsQuantityOpen(false);
        evtObj.clickText = 'SELECT DOSAGE';
        evtObj.drugFilterName = type;
        if (!isDosageOpen) _.triggerGTMVirtualPageViewEvent(evtObj);
        break;
      }
      case 'quantity': {
        setIsBrandOpen(false);
        setIsFormOpen(false);
        setIsDosageOpen(false);
        setIsQuantityOpen(!isQuantityOpen);
        evtObj.clickText = 'SELECT QUANTITY';
        evtObj.drugFilterName = type;
        if (!isQuantityOpen) _.triggerGTMVirtualPageViewEvent(evtObj);
        break;
      }
    }
  };

  const setSelected = async (type, value) => {
    switch (type) {
      case 'brand': {
        setSelectedBrand(value);
        setCustomQty('');
        let drugBrandType = value?.drugType
          ? value?.drugType
          : value.isGeneric
          ? 'Generic'
          : 'Brand';
        _.triggerGTMVirtualPageViewEvent({
          ...props.dataLayerEventObj,
          event: 'drugFilterItemSelect',
          formId: 'dosage',
          clickText: value.brand,
          drugBrand: value.brand,
          drugBrandType: drugBrandType,
          drugFilterName: type
        });
        break;
      }
      case 'form': {
        setSelectedForm(value);
        setCustomQty('');
        _.triggerGTMVirtualPageViewEvent({
          ...props.dataLayerEventObj,
          event: 'drugFilterItemSelect',
          formId: 'dosage',
          clickText: value,
          drugForm: value,
          drugFilterName: type
        });
        break;
      }
      case 'dosage': {
        setSelectedDosage(value);
        setCustomQty('');
        _.triggerGTMVirtualPageViewEvent({
          ...props.dataLayerEventObj,
          event: 'drugFilterItemSelect',
          formId: 'dosage',
          clickText: value,
          drugDosage: value,
          drugFilterName: type
        });
        break;
      }
      case 'quantity': {
        setSelectedQuantity(value);
        setIsQuantityOpen(!isQuantityOpen);
        setCustomQty('');
        _.triggerGTMVirtualPageViewEvent({
          ...props.dataLayerEventObj,
          event: 'drugFilterItemSelect',
          formId: 'dosage',
          clickText: value,
          drugQuantity: value,
          drugFilterName: type
        });
        break;
      }
    }
    await updateDosage(type, value);
  };

  const setCustomSelected = async value => {
    setSelectedQuantity(value);
    setIsQuantityOpen(!isQuantityOpen);
    setCustomQty(value);
    _.triggerGTMVirtualPageViewEvent({
      ...props.dataLayerEventObj,
      event: 'customQuantitySubmit',
      formId: 'quantity',
      drugQuantity: value,
      drugFilterName: 'custom quantity'
    });
    await updateDosage('customQuantity', value);
  };
  const handleCustomQuantityFocus = () => {
    _.triggerGTMVirtualPageViewEvent({
      ...props.dataLayerEventObj,
      event: 'customQuantityInputFieldSelect',
      formId: 'quantity',
      drugQuantity: customQuantity,
      drugFilterName: 'custom quantity'
    });
  };

  /**
   * Alert if clicked on outside of element
   */
  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsBrandOpen(false);
      setIsFormOpen(false);
      setIsDosageOpen(false);
      setIsQuantityOpen(false);
    }
  };

  const togglePriceModal = zipcode => {
    setShowPriceModal(!showPriceModal);
    if (zipcode && !_.isEqual(zipcode, zipCode)) {
      props.handleZipCodeChange(zipcode);
    }
  };

  const onBlurDrugOption = (type, event) => {
    event.preventDefault();
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName === '' || relatedClassName.includes('doneButton')) {
        return;
      }
      if (!relatedClassName.includes('custom-option')) {
        toggleDropDown(type);
      }
    }
  };

  let customQTYComponent = _.checkIfCustomQtyVisible(selectedForm) && (
    <CustomQuantity
      quantity={isNaN(parseInt(customQty)) ? 0 : parseInt(customQty)}
      handleCustomQuantityUpdate={setCustomSelected}
      handleFocus={handleCustomQuantityFocus}
    />
  );

  return (
    <>
      <section id="modal-rx-filter" ref={wrapperRef}>
        <div className="modal-header">
          <button type="button" className="sc-icon-close" aria-label="Close" />
          <p className="modal-header--text">Edit your dosage</p>
        </div>
        <div className="modal-body filter-content modal-rx-filter--content">
          <div className="rx-filters-main hiddenPricingData">
            <input
              id="drugNDC"
              name="Drug ndc"
              type="hidden"
              defaultValue={drugNdc}
            />
            <input
              id="zip-code"
              name="zip Code"
              type="hidden"
              defaultValue={zipcodeValue}
            />
            <input
              id="drugname"
              name="Drug Name"
              type="hidden"
              defaultValue={brandTypes[brandId].brand}
            />
            <input
              id="drug-display-quantity"
              name="displayQuantity"
              type="hidden"
              defaultValue={customQty || quantities[quantityId].displayQuantity}
            />
            <input
              id="drug-quantity"
              name="Quantity"
              type="hidden"
              defaultValue={quantities[quantityId].quantity}
            />
            <input
              id="drug-dosage"
              name="Dosage"
              type="hidden"
              defaultValue={dosage[dosageId].dosage}
            />
            <input
              id="drug-form"
              name="Form"
              type="hidden"
              defaultValue={formTypes[formId].name}
            />
            <input
              id="brand-generic"
              name="Brand/Generic"
              type="hidden"
              defaultValue={
                props.brandTypes[props.drugIds.brandId].isGeneric
                  ? t('Generic')
                  : 'Brand'
              }
            />

            <SelectDiv
              tabIndex={'0'}
              classes={'custom-select-wrapper firstSelect themeFocus'}
              aria={{
                'aria-haspopup': 'listbox',
                'aria-label': _.capitalize(t('SELECT BRAND'))
              }}
              isDropDownOpen={isBrandOpen}
              onClick={() => {
                if (brandTypes.length === 1) {
                  return;
                }
                toggleDropDown('brand');
              }}
            >
              <div className="selectLabel">
                <span>{t('Brand vs. Generic')}</span>
              </div>
              <div
                className={isBrandOpen ? 'custom-select open' : 'custom-select'}
              >
                <div
                  className={
                    brandTypes.length === 1
                      ? 'custom-select__trigger inactive'
                      : 'custom-select__trigger'
                  }
                >
                  <span>{selectedBrand.brand}</span>
                  {!_.isUndefined(selectedBrand.brand) && (
                    <span className="tooltip">
                      <i className="arrowUp"></i>
                      <span>
                        {`${
                          _.isEmpty(selectedBrand?.drugType)
                            ? selectedBrand.isGeneric
                              ? t('Generic')
                              : t('Brand')
                            : selectedBrand?.drugType
                        }: ${selectedBrand.brand}`}
                      </span>
                    </span>
                  )}
                  <div className="arrow"></div>

                  <SelectList
                    className={'custom-options w190'}
                    selectName={t('SELECT BRAND')}
                    itemsList={brandTypes}
                    selectedState={selectedBrand}
                    type={'brand'}
                    displayKey={'brand'}
                    onClick={setSelected}
                    onBlur={onBlurDrugOption}
                    toLower="false"
                  />
                </div>
              </div>
            </SelectDiv>

            <SelectDiv
              tabIndex={'0'}
              classes={'custom-select-wrapper secondSelect themeFocus'}
              aria={{
                'aria-haspopup': 'listbox',
                'aria-label': _.capitalize(t('SELECT FORM'))
              }}
              isDropDownOpen={isFormOpen}
              onClick={() => {
                if (formTypes.length === 1) {
                  return;
                }
                toggleDropDown('form');
              }}
            >
              <div className="selectLabel">
                <span>{t('Form')}</span>
              </div>
              <div
                className={isFormOpen ? 'custom-select open' : 'custom-select'}
              >
                <div
                  className={
                    formTypes.length === 1
                      ? 'custom-select__trigger inactive'
                      : 'custom-select__trigger'
                  }
                >
                  <span>{selectedForm}</span>
                  {!_.isEmpty(selectedForm) && (
                    <span className="tooltip">
                      <i className="arrowUp"></i>
                      <span>{selectedForm}</span>
                    </span>
                  )}
                  <div className="arrow"></div>
                </div>

                <SelectList
                  className={'custom-options'}
                  selectName={t('SELECT FORM')}
                  itemsList={formTypes}
                  selectedState={selectedForm}
                  type={'form'}
                  displayKey={'name'}
                  onClick={setSelected}
                  onBlur={onBlurDrugOption}
                  toLower="false"
                />
              </div>
            </SelectDiv>

            <SelectDiv
              tabIndex={'0'}
              classes={'custom-select-wrapper thirdSelect themeFocus'}
              aria={{
                'aria-haspopup': 'listbox',
                'aria-label': _.capitalize(t('SELECT DOSAGE'))
              }}
              isDropDownOpen={isDosageOpen}
              onClick={() => {
                if (dosage.length === 1) {
                  return;
                }
                toggleDropDown('dosage');
              }}
            >
              <div className="selectLabel">
                <span>{t('Dosage')}</span>
              </div>
              <div
                className={
                  isDosageOpen ? 'custom-select open' : 'custom-select'
                }
              >
                <div
                  className={
                    dosage.length === 1
                      ? 'custom-select__trigger inactive'
                      : 'custom-select__trigger'
                  }
                >
                  <span>{_.toLower(selectedDosage)}</span>
                  {!_.isEmpty(selectedDosage) && (
                    <span className="tooltip">
                      <i className="arrowUp"></i>
                      <span>{_.toLower(selectedDosage)}</span>
                    </span>
                  )}
                  <div className="arrow"></div>
                </div>

                <SelectList
                  className={'custom-options'}
                  selectName={t('SELECT DOSAGE')}
                  itemsList={dosage}
                  selectedState={selectedDosage}
                  type={'dosage'}
                  displayKey={'dosage'}
                  onClick={setSelected}
                  onBlur={onBlurDrugOption}
                  toLower="true"
                />
              </div>
            </SelectDiv>

            <SelectDiv
              tabIndex={'0'}
              classes={'custom-select-wrapper fourthSelect themeFocus'}
              aria={{
                'aria-haspopup': 'listbox',
                'aria-label': _.capitalize(t('SELECT QUANTITY'))
              }}
              isDropDownOpen={isQuantityOpen}
              onClick={() => {
                if (
                  (!_.checkIfCustomQtyVisible(selectedForm) &&
                    quantities.length === 1) ||
                  event.target.classList.contains('customQntyAda')
                ) {
                  return;
                }
                toggleDropDown('quantity');
              }}
            >
              <div className="selectLabel">
                <span>{t('Quantity')}</span>
              </div>
              <div
                className={
                  isQuantityOpen ? 'custom-select open' : 'custom-select'
                }
              >
                <div
                  className={
                    !_.checkIfCustomQtyVisible(selectedForm) &&
                    quantities.length === 1
                      ? 'custom-select__trigger inactive'
                      : 'custom-select__trigger'
                  }
                >
                  <span>
                    {finalDisplayQty} {t('count')}
                  </span>
                  {finalDisplayQty != '' && (
                    <span className="tooltip">
                      <i className="arrowUp"></i>
                      <span>
                        {finalDisplayQty} {t('count')}
                      </span>
                    </span>
                  )}

                  <div className="arrow"></div>
                </div>

                <SelectList
                  className={'custom-options'}
                  selectName={t('SELECT QUANTITY')}
                  itemsList={quantities}
                  selectedState={finalDisplayQty}
                  type={'quantity'}
                  displayKey={'displayQuantity'}
                  onClick={setSelected}
                  customComponent={customQTYComponent}
                  onBlur={onBlurDrugOption}
                  toLower="false"
                />
              </div>
            </SelectDiv>
          </div>
        </div>
      </section>
      <div className="zipcodeBottom">
        {/* <Advertisting seoName={props.seoName} 
        placementPage={ADS_PLACEMENT.DRUG_PAGE}
      /> */}
        <PatientCompassAd
          patientCompassData={patientCompassData}
          seoName={props.seoName}
          placementPage={ADS_PLACEMENT.DRUG_PAGE}
        />
        <div className="zipCodeAlertWrap">
          {!props.isSpecialityDrug && !props.isSuppressedDrug && (
            <div className="topZipcode">
              <Zipcode
                zipCode={zipCode}
                handleZipCodeChange={props.handleZipCodeChange}
              />
            </div>
          )}
          {API.ALLOW_PRICE_ALERT && _.isEqual(i18n.language, 'en') && (
            <SelectDiv
              tabIndex={'0'}
              classes={'priceAlert price-alerts-cta themeFocus'}
              aria={{
                'aria-haspopup': 'dialog',
                role: 'button',
                'aria-label': t('Subscribe to Price Alerts (opens dialog)')
              }}
              onClick={() => togglePriceModal()}
            >
              <span className="priceAlertsIcon"></span>
              <label>{t('Price Alerts')}</label>
              <span className="tooltipForPriceAlert">
                <i className="arrowUp"></i>
                <span>
                  Get alerted when the price
                  <br />
                  changes more than 10%
                </span>
              </span>
            </SelectDiv>
          )}

          {_.isEqual(i18n.language, 'en') && (
            <div className="savedDrugWrapperSection">
              <SaveDrug
                drugNDC={drugNdc}
                quantity={
                  !_.isEmpty(customQuantity) ? customQuantity : props.finalQty
                }
                kclass={''}
                ispricingInProgress={showTieredPricingLoader}
                isCustomQuantity={!_.isEmpty(customQuantity)}
              />
            </div>
          )}

          {showPriceModal && _.isEqual(i18n.language, 'en') && (
            <PriceAlerts
              drugNdc={props.drugNdc}
              hidepriceModal={togglePriceModal}
              drugName={selectedBrand.brand}
              selectedDosage={_.toLower(selectedDosage)}
              quantity={finalDisplayQty}
              form={selectedForm}
              lowestPrice={props.lowestPriceForAleart}
              zipcodeValue={
                _.isEqual(zipcodeValue, DEFAULT_ZIPCODE) ? '' : zipcodeValue
              }
              seoName={props.seoName}
              finalQty={
                !_.isEmpty(customQuantity) ? customQuantity : props.finalQty
              }
              isCustomQuantity={!_.isEmpty(customQuantity) ? true : false}
              userName={props.userName}
              showPriceModal={showPriceModal}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default DosageSelection;
